var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlayStroke = function SvgPlayStroke(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0
    },
    d: "M18.75 3.75H15.375C14.9608 3.75 14.625 4.08579 14.625 4.5V19.5C14.625 19.9142 14.9608 20.25 15.375 20.25H18.75C19.1642 20.25 19.5 19.9142 19.5 19.5V4.5C19.5 4.08579 19.1642 3.75 18.75 3.75Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "            M6.7 20.1958            V3.80425            C6.7 3.56863 6.95919 3.42497 7.159 3.54986            L20.2722 11.7457            C20.4602 11.8632 20.4602 12.137 20.2722 12.2545            L20.2722 12.2545            C20.2722 12.2545 20.4602 12.137 20.2722 12.2545            L7.159 20.4502            C6.95918 20.575 6.7 20.4314 6.7 20.1958            "
  }, /*#__PURE__*/React.createElement("animate", {
    className: "animation-to-pause",
    begin: "indefinite",
    dur: "0.2s",
    fill: "freeze",
    attributeName: "d",
    to: "           M4.5 19.9142           V4.08579           C4.5 4.08579 4.5 3.75 4.83579 3.75            L9.03921 3.75           C8.625 3.75 9.375 3.75 9.375 4.08579           L9.375 19.9142           C9.375 19.9142 9.375 20.25 8.625 20.25           L4.83579 20.25           C4.83579 20.25 4.5 20.25 4.5 19.9142         "
  }), /*#__PURE__*/React.createElement("animate", {
    className: "animation-to-play",
    begin: "indefinite",
    dur: "0.2s",
    fill: "freeze",
    attributeName: "d",
    to: "           M6.7 20.1958           V3.80425           C6.7 3.56863 6.95919 3.42497 7.159 3.54986           L20.2722 11.7457           C20.4602 11.8632 20.4602 12.137 20.2722 12.2545           L20.2722 12.2545           C20.2722 12.2545 20.4602 12.137 20.2722 12.2545           L7.159 20.4502           C6.95918 20.575 6.7 20.4314 6.7 20.1958         "
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayStroke);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/svg-icons/play-stroke.svg";